import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { WaiversPoliciesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export const usePolicyGet = (id: number) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.Waivers, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(WaiversPoliciesApi, accessToken);
      return service.getPolicyById({ id });
    },
    enabled: !!accessToken && !!id,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    refetch,
  };
};

